<template>
  <v-container fluid>
    <ValidationObserver ref="observer" v-slot="{ validate, reset }">
      <v-dialog v-model="dialog" v-if="dialog" max-width="80vw">
        <!-- <v-btn slot="activator" color="primary" dark class="mb-2" @click="addEntry">New Dealer</v-btn> -->
        <v-card>
          <v-card-title>
            <v-title>Dealer Details</v-title>
          </v-card-title>
          <v-card-text>
            <v-form pa-0 ma-0 v-model="valid" lazyValidation>
              <v-container fluid>
                <v-layout row wrap>
                  <v-flex xs3>
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="ubDealerID"
                      rules="required"
                    >
                      <v-text-field
                        name="ubDealerID"
                        v-model="editedItem.ubDealerID"
                        label="Dealer ID"
                        :error-messages="errors"
                        readonly
                      ></v-text-field>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs4>
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="dealerFullName"
                      rules="required"
                    >
                      <v-text-field
                        v-model="editedItem.dealerFullName"
                        label="Full Name"
                        name="dealerFullName"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs5>
                    <v-text-field
                      v-model="editedItem.lastLoggedIn"
                      name="lastLoggedIn"
                      label="Last Logged In Date"
                      disabled
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs4 class="email-container">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="dealerEmail"
                      rules="required"
                    >
                      <v-text-field
                        name="dealerEmail"
                        v-model="editedItem.dealerEmail"
                        label="Dealer Email"
                        :error-messages="errors"
                        readonly
                      ></v-text-field>

                      <v-icon v-show="emailHistory.length > 0 || allFlags.SOG8904" @click="showEmailHistory" class="history-icon secondary--text">history</v-icon>

                      <v-dialog v-model="emailHistoryDialog" max-width="900px">
                        <v-card>
                          <v-card-title>
                            <v-title>Dealer's Email Change History</v-title>
                            <v-layout row wrap mt-4 v-if="allFlags.SOG8904" class="outlined-border">
                              <v-flex xs4>
                                <ValidationProvider
                                  v-slot="{ errors }"
                                  name="new dealer email"
                                  rules="required|email"
                                >
                                  <v-text-field
                                    name="newDealerEmail"
                                    v-model="newDealerEmail"
                                    label="Enter new email address"
                                    :error-messages="errors"
                                  ></v-text-field>
                                </ValidationProvider>
                              </v-flex>
                              <v-flex xs3 class="mx-3">
                                <v-text-field
                                  name="requestedBy"
                                  v-model="requestedBy"
                                  label="Requested By"
                                  :error-messages="errors"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs3>
                                <v-text-field
                                  name="jiraCard"
                                  v-model="jiraCard"
                                  label="Jira Card"
                                  :error-messages="errors"
                                ></v-text-field>
                              </v-flex>
                              <v-spacer></v-spacer>
                              <v-flex xs1 mt-2 mr-3>
                                <v-btn color="primary" @click="changeEmail" :disabled="disableUpdateButton" dense>Update</v-btn>
                              </v-flex>
                            </v-layout>
                            
                            <v-data-table
                              :items="emailHistory"
                              :headers="emailHistoryHeaders"
                              :loading="loading"
                              style="width: 100%;"
                            >
                            <template slot="items" slot-scope="props">
                              <td
                                v-for="(header, index) in emailHistoryHeaders"
                                :key="index"
                                :class="'text-xs-' + header.align"
                              >
                              <span v-if="header.value === 'deactivationDate'">{{ props.item[header.value] | formatDate }}</span>
                              <span v-else>{{ props.item[header.value] }}</span>
                              </td>
                            </template>
                          </v-data-table>
                          </v-card-title>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="emailHistoryDialog = false">Close</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs4>
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="dealerStatus"
                      rules="required"
                    >
                      <v-text-field
                        name="dealerStatus"
                        v-model="editedItem.dealerStatus"
                        label="Dealer Status"
                        :error-messages="errors"
                        readonly
                      ></v-text-field>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs4>
                    <ValidationProvider v-slot="{ errors }" name="groupNo">
                      <v-text-field
                        name="groupNo"
                        v-model="editedItem.groupNo"
                        label="Group No"
                        :error-messages="errors"
                        type="number"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12>
                    <!-- <v-btn
                      color="success"
                      @click="getContract(editedItem.ubDealerID)"
                      :disabled="!isSigned(editedItem)"
                    >
                      Get Contract
                    </v-btn> -->
                    <v-btn
                      color="success"
                      @click="onOpenContractDialog(false)"
                      :disabled="!isSigned(editedItem)"
                    >
                      Get Contract
                    </v-btn>
                    <v-btn
                      color="success"
                      @click="onOpenContractDialog(true)"
                    >
                      Upload Contract
                    </v-btn>
                  </v-flex>
                  <hr />
                  <component
                    :is="'auth-details'"
                    :dealer="editedItem"
                  ></component>

                  <v-title>Commissions</v-title>
                  <v-flex xs6>
                    <v-checkbox
                      v-model="editedDealerManager.produceRcti"
                      label="Produce Commissions"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                      item-text="dealerType"
                      item-value="id"
                      :items="dealerTypes"
                      v-model="editedDealerManager.dealerTypeID"
                      label="Dealer Type"
                    ></v-select>
                  </v-flex>
                  <template>
                    <v-spacer>
                      <v-title>Auth0 Function</v-title>
                    </v-spacer>
                    <v-flex xs12>
                      <v-btn
                        color="secondary"
                        @click="searchAuth0(editedItem.dealerEmail)"
                      >
                        Check Login Email
                      </v-btn>
                      <v-btn
                        v-if="editedItem.deactivated"
                        color="secondary"
                        @click="createUserAuth(editedItem.dealerEmail)"
                      >
                        Create Login Account
                      </v-btn>
                      <v-btn
                        v-if="!editedItem.deactivated"
                        color="secondary"
                        @click="resetPassword(editedItem.dealerEmail)"
                      >
                        Reset Login Password
                      </v-btn>
                      <v-btn
                        v-if="!editedItem.deactivated"
                        color="error"
                        @click="deactivate(editedItem.dealerID)"
                      >
                        Deactivate User
                      </v-btn>
                      <v-btn
                        v-if="!editedItem.deactivated"
                        color="purple"
                        class="white--text"
                        @click="resetMFA(editedItem.dealerEmail)"
                      >
                        Reset Multi-factor Auth
                      </v-btn>
                    </v-flex>
                  </template>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click.native="save">
              Save
            </v-btn>
            <v-btn color="light-grey" @click.native="close">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="authDialog" max-width="700px">
        <v-card>
          <v-card-title>
            <v-title>Dealer Auth Details</v-title>
          </v-card-title>
          <v-card-text>
            <v-form v-if="editedAuth.length >= 1">
              <v-layout
                row
                wrap
                v-for="(prop, propIndex) in editedAuth"
                :key="propIndex"
              >
                <v-flex xs4>
                  <v-select
                    :items="applications"
                    v-model="prop.applicationID"
                    item-value="id"
                    item-text="text"
                    label="Application"
                  ></v-select>
                </v-flex>
                <v-flex>
                  <v-select
                    :items="authLevels"
                    item-value="val"
                    item-text="label"
                    v-model="prop.authLevel"
                    label="Level of Authorisation"
                  ></v-select>
                </v-flex>
                <v-flex xs2>
                  <v-btn
                    color="red"
                    v-if="prop.authID"
                    dark
                    @click.native="deleteAuth(prop)"
                  >
                    Delete
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-form>
            <v-alert v-else :value="true" color="red" icon="warning">
              This dealer has no authorisation.
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-btn
              v-if="allFlags.SOG3257 && userGroup == 0"
              color="error"
              @click="revokeDealer"
            >
              Remove Dealer Record
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="addAuth">Add Auth</v-btn>
            <v-btn color="primary" @click.native="saveAuth">
              Update Auth Level
            </v-btn>

            <v-btn color="light-grey" @click.native="closeAuth">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-title>Dealer Logins</v-title>
      <div>
        <v-layout row wrap mt-4>
          <v-flex mr-2>
            <v-text-field
              name="Search"
              label="Search"
              v-model="SearchText"
              append-icon="search"
            ></v-text-field>
          </v-flex>
          <v-flex mr-2>
            <v-checkbox
              v-model="showRejected"
              label="Show Rejected"
            ></v-checkbox>
          </v-flex>
          <v-flex mr-2>
            <v-checkbox
              v-model="showDeactivated"
              label="Show Deactivated"
              v-if="allFlags.SOG4881"
            ></v-checkbox>
          </v-flex>
          <v-flex mr-2 xs2>
            <v-select
              v-model="userGroup"
              :items="userGroupList"
              item-text="name"
              item-value="value"
              label="User group"
              dense
              outlined
              hide-details
            ></v-select>
          </v-flex>
          <v-flex mr-2>
            <v-btn block color="success" @click="checkMissingCustomers">
              Check Missing Customers
            </v-btn>
          </v-flex>
          <v-flex mr-2>
            <v-btn block color="primary" @click="updateDealerInfo">
              Update Dealer Info
            </v-btn>
          </v-flex>
          <v-flex mr-2>
            <v-btn block color="secondary" @click="openCpLogDialog">
              New CP Log
            </v-btn>
          </v-flex>
        </v-layout>
      </div>

      <v-data-table
        :total-items="paginatedDealerList.total"
        :pagination.sync="pagination"
        :options.sync="options"
        :items="paginatedDealerList.data"
        :headers="headers"
        :loading="loading"
      >
        <template slot="items" slot-scope="props">
          <td
            v-for="(prop, propIndex) in headers.filter(
              x => x.text !== 'Actions'
            )"
            :key="propIndex"
            :class="'ma-0'"
          >
            <div v-if="prop.autocomplete" :class="'text-xs-' + prop.align">
              {{ props.item[prop.value][prop.nested] }}
            </div>

            <div v-else :class="'text-xs-' + prop.align">
              <div v-if="prop.date">
                {{ props.item[prop.value] | formatDate }}
              </div>
              <div v-else>{{ props.item[prop.value] }}</div>
            </div>
          </td>

          <td class="justify-center layout px-0">
            <v-btn icon class="mx-0" @click="editItem(props.item)">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <v-btn icon class="mx-0" @click="showAuthEdit(props.item)">
              <v-icon color="teal">account_box</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
      <v-flex sm12 md12 lg12>
        <message-alert :component="message"></message-alert>
      </v-flex>
    </ValidationObserver>
    
    <v-dialog v-model="cpLogDialog" max-width="1500px" persistent>
      <v-card>
        <v-card-title class="pa-0">
          <v-title>Newly Onboarded Channel Partners</v-title>
        </v-card-title>
        <v-flex class="mx-4" style="max-width:500px;">
          <v-text-field
            v-model="cpSearchText"
            label="Search"
            append-icon="search"
            dense
          ></v-text-field>
        </v-flex>
        <v-data-table
          :total-items="paginatedCpLogList.total"
          :pagination.sync="cpPagination"
          :options.sync="cpOptions"
          :items="paginatedCpLogList.data || []"
          :headers="cpHeaders"
          :loading="loading"
        >
          <template slot="items" slot-scope="props">
            <td v-for="(prop, propIndex) in cpHeaders" :key="propIndex" :class="'text-' + (prop.align || 'left')">
              <span v-if="prop.value === 'createdDate'">{{ props.item[prop.value] | formatDate }}</span>
              <span v-else-if="prop.value === 'status'">{{ props.item[prop.value].charAt(0).toUpperCase() + props.item[prop.value].slice(1) }}</span>
              <span v-else-if="prop.value === 'resultMessageID'">{{ (resultMessages.find(m => m.id === props.item.resultMessageID) || {}).value || props.item.resultMessageID }}</span>
              <span v-else-if="prop.value === 'documentStatus'">{{ props.item[prop.value] ? 'Sent' : 'N/A' }}</span>
              <span v-else>{{ props.item[prop.value] }}</span>
            </td>
          </template>
        </v-data-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="light-grey" @click.native="closeCpLogDialog">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="contractDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="pa-0">
          <v-title>{{  isUpload ? "Upload" : "Get"  }} Contract</v-title>
        </v-card-title>
        <v-card-text class="px-0">
          <v-form pa-0 ma-0 v-model="valid" lazyValidation>
            <v-layout row wrap v-if="isUpload">
              <v-flex xs12>
                <input
                  ref="fileInput"
                  type="file"
                  @change="file = $event.target.files"
                  accept="application/pdf"
                  class="input-file"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap v-else>
              <v-flex xs12>
                <v-select
                  v-model="selectedContract"
                  :items="dealerContracts"
                  label="Select Contract to Download"
                  name="dealerContracts"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="isUpload" color="primary" @click.native="onUploadContract(editedItem.ubDealerID)">
            Upload
          </v-btn>
          <v-btn v-else color="primary" @click.native="onDownloadContract(editedItem.ubDealerID)">
            Download
          </v-btn>
          <v-btn color="light-grey" @click.native="closeContractDialog">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loader-dialog :showLoader="isLoading" :stockDialog="true"></loader-dialog>
  </v-container>
</template>

<script>
import { mapActions, createNamespacedHelpers } from 'vuex';
import { mapMultiRowFields } from 'vuex-map-fields';
import {
  mapDealerFields,
  mapDealerMultiRowFields,
} from '../store/modules/orders';
const { mapGetters: mapOrderGetters } = createNamespacedHelpers(`orders`);

const {
  mapActions: mapDealerActions,
  mapMutations: mapDealerMutations,
} = createNamespacedHelpers(`orders/dealer`);
import { httpError } from '../models/httpError';
import { Dealer } from '../models/Dealer';
import { DealerManager } from '../models/dealerPortal/DealerManager';
import AuthDetails from '@/components/admin/auth-details';
const { mapGetters: mapFeatureFlagGetters } = createNamespacedHelpers(
  `orders/featureFlag`
);

import LoaderDialog from '../components/common/LoaderDialog.vue';
import dealer from '../store/modules/forms/dealer';
export default {
  name: 'editDealers',
  components: {
    AuthDetails,
    LoaderDialog,
  },
  data: () => ({
    contractDialog: false,
    cpLogDialog: false,
    file: null,
    isUpload: false,
    dealerContracts: [],
    selectedContract: "",
    isLoading: false,
    userGroup: 0,
    userGroupList: [
      {
        name: 'Dealers',
        value: 0,
      },
      {
        name: 'Customers',
        value: 1,
      },
      {
        name: 'Employees',
        value: 2,
      },
    ],
    showRejected: false,
    showDeactivated: false,
    valid: true,
    dialog: false,
    editedItem: new Dealer(),
    editedIndex: 0,
    authDialog: false,
    SearchText: null,
    cpSearchText: null,
    editedDealerManager: new DealerManager(),
    editedAuth: [],
    items: [],
    totalItems: 0,
    hasLink: false,
    dealerID: 0,
    ubDealerID: 0,
    applications: [
      { id: 1, text: 'Signonglass' },
      { id: 2, text: 'Link' },
      { id: 3, text: 'GeeksLink' },
      { id: 4, text: 'Commissions' },
    ],
    authLevels: [
      { val: -2, label: 'Unauthorised' },
      { val: -1, label: 'Interested' },
      { val: 0, label: 'Employee' },
      { val: 1, label: 'Dealer' },
      { val: 2, label: 'Admin' },
      { val: 3, label: 'Customer' },
      { val: 5, label: 'Direct Sales' },
    ],
    pagination: {
      page: 1,
      rowsPerPage: 25,
      totalItems: 0,
      descending: true,
    },
    options: {},
    loading: false,
    headers: [
      {
        text: 'Dealer ID',
        align: 'right',
        sortable: true,
        value: 'ubDealerID',
      },
      {
        text: 'Full Name',
        align: 'right',
        sortable: true,
        value: 'dealerFullName',
      },
      {
        text: 'Dealer Email',
        align: 'right',
        sortable: true,
        value: 'dealerEmail',
      },
      {
        text: 'Contract Status',
        align: 'right',
        sortable: true,
        value: 'dealerStatus',
      },
      {
        text: 'Group No',
        align: 'right',
        sortable: true,
        value: 'groupNo',
      },
      {
        text: 'Last Logged In',
        align: 'right',
        date: 'lastLoggedIn',
        sortable: true,
        value: 'lastLoggedIn',
      },
      {
        text: 'Actions',
        value: 'name',
        sortable: false,
      },
    ],
    cpHeaders: [
        {
          text: 'Email',
          align: 'left',
          sortable: false,
          value: 'email',
        },
        {
          text: 'First Name',
          align: 'left',
          sortable: false,
          value: 'firstName',
        },
        {
          text: 'Last Name',
          align: 'left',
          sortable: false,
          value: 'lastName',
        },
        {
          text: 'Dealer ID',
          align: 'left',
          sortable: false,
          value: 'dealerID',
        },
        {
          text: 'CP Manager ID',
          align: 'left',
          sortable: false,
          value: 'approvingCPManagerID',
        },
        {
          text: 'Status',
          align: 'left',
          sortable: false,
          value: 'status',
        },
        {
          text: 'UPilot ID',
          align: 'left',
          sortable: false,
          value: 'uPilotID',
        },
        {
          text: 'Created Date',
          align: 'left',
          sortable: false,
          value: 'createdDate',
        },
        {
          text: 'Result Message',
          align: 'left',
          sortable: false,
          value: 'resultMessageID',
        },
        {
          text: 'Document Status',
          align: 'left',
          sortable: false,
          value: 'documentStatus',
        },
      ],
    paginatedDealerList: {},
    paginatedCpLogList: {},
    cpPagination: {
      page: 1,
      rowsPerPage: 25,
      totalItems: 0,
      descending: true,
    },
    cpOptions: {},
    resultMessages: [
      { id: 1, value: 'Dealer exists in SOG; details updated' },
      { id: 2, value: 'Email address exists in UB' },
      { id: 3, value: 'Channel Partner is currently being processed' },
      { id: 4, value: 'Required fields (email, first name, last name) are missing in UPilot'},
    ],
    emailHistoryDialog: false,
    emailHistory: [],
    newDealerEmail: '',
    requestedBy: '',
    jiraCard: '',
  }),
  computed: {
    ...mapDealerFields(['message', 'dealerTypes']),
    ...mapOrderGetters(['authLevel', 'isAdmin']),
    ...mapFeatureFlagGetters(['allFlags']),
    filtereditems: function() {
      let result = this.items.filter(this.isValid);

      return result.filter(x =>
        this.showRejected
          ? x.dealerStatus == 'Rejected'
          : x.dealerStatus !== 'Rejected'
      );
    },
    filteredUserGroup: function() {
      let result = this.items.filter(this.isValid);

      switch (this.userGroup) {
        case 0:
          result = result.filter(
            x =>
              ['customer', 'employee'].indexOf(x.dealerStatus.toLowerCase()) ===
              -1
          );
          break;
        case 1:
          result = result.filter(
            x => x.dealerStatus.toLowerCase() == 'customer'
          );
          break;
        case 2:
          result = result.filter(x => x.isEmployee);
          break;

        default:
          break;
      }

      return result;
    },
    emailHistoryHeaders() {
      return [
        {
          text: 'Email Address',
          align: 'left',
          sortable: false,
          value: 'email',
        },
        {
          text: 'Replaced Email',
          align: 'left',
          sortable: false,
          value: 'replacedEmail',
        },
        {
          text: 'Deactivation Date',
          align: 'left',
          sortable: false,
          value: 'deactivationDate',
        },
        {
          text: 'Requested By',
          align: 'left',
          sortable: false,
          value: 'requestedBy',
        },
        ...(this.allFlags.SOG8904
        ? [{
            text: 'Jira Card Number',
            align: 'left',
            sortable: false,
            value: 'jiraCard'
          }]
        : []),
      ]
    },
    disableUpdateButton() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return (
        this.jiraCard == '' ||
        !this.requestedBy ||
        !emailPattern.test(this.newDealerEmail || '')
      );
    }
  },

  methods: {
    checkMissingCustomers() {
      this.isLoading = true;

      this.$store
        .dispatch(`distinctCustomers/checkMissingCustomers`)
        .then(() => {})
        .finally(() => {
          this.isLoading = false;
        });
    },
    updateDealerInfo() {
      this.refreshDealer();
    },
    ...mapDealerActions([
      'listDealers',
      'saveDealer',
      'setMessage',
      'resetPassword',
      'searchAuth0',
      'createAuth',
      'getContract',
      'getDealerContract',
      'uploadContract',
      'getContractList',
      'removeDealer',
      'listDealersManagement',
      'paginadtedListDealersManagement',
      'getNewChannelPartnerLog',
      'getDealerManager',
      'getDealerAuthList',
      'updateDealerManager',
      'updateDealerAuth',
      'sendLinkEmail',
      'deleteDealerAuth',
      'refreshDealer',
      'updateDealerData',
      'getDealerTypes',
      'updateDealerDetails',
      'revokeDealerPermission',
      'deactivateUser',
      'resetUserMFA',
      'getDealerEmailAddressLog',
      'recordDealerEmailChange',
      'checkDealerEmailAddressExist',
    ]),
    ...mapDealerMutations(['addRow']),
    async resetMFA(email) {
      let vm = this;
      await vm.resetUserMFA(email).then(() => {});
    },
    async deactivate(id) {
      let vm = this;
      await this.deactivateUser(id).then(() => {
        vm.listDealersManagement()
          .then(data => {
            vm.items = data;
            vm.total = data.length;
            vm.loading = false;
            vm.dialog = false;
          })
          .catch(() => {});
      });
    },
    async createUserAuth(email) {
      let vm = this;
      await vm.createAuth(email).then(() => (vm.dialog = false));
    },
    addEntry() {
      this.setMessage(new httpError());
      this.editedIndex = this.addRow();
      this.editedItem = this.items[this.editedIndex];
    },
    async editItem(item) {
      this.setMessage(new httpError());
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = item;
      this.dialog = true;
      this.getDealerEmailAddressLog(item.ubDealerID).then(data => {
        this.emailHistory = data || [];
      });
      this.editedDealerManager = await this.getDealerManager(item.ubDealerID);
    },
    showAuthEdit(item) {
      let vm = this;
      vm.authDialog = true;
      vm.dealerID = item.dealerID;
      vm.ubDealerID = item.ubDealerID;
      if (vm.allFlags.SOG2255) {
        vm.getDealerAuthList(item).then(result => {
          vm.editedAuth = result;
          vm.editedAuth[0].dealerID = item.dealerID;
          vm.hasLink = result.filter(x => x.applicationID == 2).length > 0;
        });
      } else {
        vm.getDealerAuthList(item).then(result => {
          vm.editedAuth = result;
          //   vm.editedAuth[0].dealerID = item.ubDealerID;
        });
      }
    },
    revokeDealer() {
      let vm = this;
      vm.$dialog
        .confirm('Are you sure you want to remove dealer SOG record?')
        .then(async () => {
          vm.revokeDealerPermission(vm.ubDealerID)
            .then(data => {
              if (data) {
                vm.authDialog = false;
                vm.listDealersManagement()
                  .then(data => {
                    vm.items = data;
                    vm.total = data.length;
                    vm.loading = false;
                  })
                  .catch(() => {});

                vm.setMessage(
                  new httpError({
                    message: 'Dealer records removed!',
                    httpStatus: 200,
                  })
                );
              }
            })
            .catch(err => {
              vm.setMessage(
                new httpError({
                  message: 'Failed to revoke permission!',
                  httpStatus: 500,
                })
              );
            });
        })
        .catch(err => {
          console.log(err);
        });
    },
    deleteItem(item) {
      this.setMessage(new httpError());
      let answer = confirm('Are you sure you want to delete this item?');
      if (answer) {
        this.removeDealer(item.ubDealerID)
          .then(data => {
            //this.items.splice(index, 1);
          })
          .catch(() => {});
      }
    },
    deleteAuth(item) {
      let vm = this;
      vm.deleteDealerAuth(item.authID).then(() => {
        vm.editedAuth = vm.editedAuth.filter(x => x.authID !== item.authID);
      });
    },
    addAuth() {
      let auth = {};
      Object.assign(auth, this.editedAuth[0]);
      auth.authID = 0;
      auth.applicationID = 1;
      auth.dealerID = this.dealerID;
      if (!this.editedAuth) this.editedAuth = [];
      this.editedAuth.push(auth);
    },
    isSigned(editedItem) {
      if (
        ['onboarding', 'not yet in ub'].includes(
          editedItem.dealerStatus ? editedItem.dealerStatus.toLowerCase() : ''
        )
      )
        return true;
      return false;
    },
    isValid: function(item) {
      let vm = this;
      if (vm.SearchText === null) return true;
      const filters = vm.headers.filter(x => x.sortable).map(x => x.value);

      for (var i = 0; i < filters.length; i++) {
        if (item[filters[i]] !== null) {
          if (
            item[filters[i]]
              .toString()
              .toUpperCase()
              .includes(vm.SearchText.toUpperCase())
          )
            return true;
        }
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    closeAuth() {
      this.authDialog = false;
      setTimeout(() => {
        this.editedAuth = {};
      }, 300);
    },
    saveAuth() {
      let vm = this;
      if (vm.allFlags.SOG2255) {
        vm.isLoading = true;
        // vm.editedAuth[0].dealerID = vm.dealerID;
        vm.updateDealerAuth(vm.editedAuth)
          .then(result => {
            let isDealer = result
              .filter(x => x.applicationID == 2)
              .map(x => x.authLevel == 1)[0];

            if (!vm.hasLink && isDealer) {
              vm.sendLinkEmail(vm.editedAuth.dealerID).then(() => {
                vm.isLoading = false;
                vm.closeAuth();
              });
            } else {
              vm.isLoading = false;
              vm.closeAuth();
            }
          })
          .catch(() => vm.closeAuth());
      } else {
        vm.updateDealerAuth(vm.editedAuth)
          .then(() => vm.closeAuth())
          .catch(() => vm.closeAuth());
      }
    },
    save() {
      let vm = this;
      vm.$refs.observer.validate().then(async result => {
        if (result) {
          if (vm.editedItem.dealerStatus.toLowerCase() === 'customer') {
            vm.updateDealerDetails(vm.editedItem)
              .then(() => {
                vm.saveDealer(vm.editedItem)
                  .then(() => vm.close())
                  .catch(() => vm.close());
              })
              .catch(() => vm.close());
          } else {
            vm.updateDealerData(vm.editedDealerManager)
              .then(() => {
                vm.saveDealer(vm.editedItem)
                  .then(() => vm.close())
                  .catch(() => vm.close());
              })
              .catch(() => vm.close());
          }
        } else
          vm.setMessage(
            new httpError({
              message: 'Not all required fields filled out',
              httpStatus: 500,
            })
          );
      });
    },
    navigate: function(route) {
      this.$router.push(route);
    },
    getPaginatedDealerList() {
      let vm = this;
      vm.paginadtedListDealersManagement({
        dealerType: vm.userGroup,
        keyword: vm.SearchText,
        showRejected: vm.showRejected,
        showDeactivated: vm.showDeactivated,
        pagination: {
          pageNo: vm.pagination.page,
          pageSize:
            vm.pagination.rowsPerPage < 0
              ? vm.paginatedDealerList.total
              : vm.pagination.rowsPerPage,
          orderBy: vm.pagination.sortBy,
          descending: vm.pagination.descending,
        },
      }).then(data => {
        vm.paginatedDealerList = data;
      });
    },
    getPaginatedCpLogList() {
      let vm = this;
      vm.getNewChannelPartnerLog({
        keyword: vm.cpSearchText,
        pagination: {
          pageNo: vm.cpPagination.page,
          pageSize:
            vm.cpPagination.rowsPerPage < 0
              ? vm.paginatedCpLogList.total
              : vm.cpPagination.rowsPerPage,
          orderBy: vm.cpPagination.sortBy,
          descending: vm.cpPagination.descending,
        },
      }).then(data => {
        vm.paginatedCpLogList = data;
      });
    },
    onDownloadContract(dealerId) {
      let vm = this;
      vm.getDealerContract({
        dealerID: dealerId,
        file: vm.selectedContract
      }).then(() => {
        vm.closeContractDialog()
      })
    },
    onUploadContract(dealerId) {
      let vm = this;
      const formData = new FormData();
      formData.append("file", vm.file[0]);
      vm.uploadContract({
        dealerID: dealerId, 
        file: formData
      }).then(() => {
        vm.closeContractDialog()
      })
    }, 
    onOpenContractDialog(newContract = false) {
      let vm = this;
      vm.isUpload = newContract
      if(!newContract) {
        vm.getContractList(vm.editedItem.ubDealerID).then(data => {
          vm.dealerContracts = data
        })
      }

      vm.contractDialog = true;
    },
    closeContractDialog() {
      let vm = this;
      vm.file = null;
      vm.dealerContracts = [];
      if(vm.isUpload) {
        vm.$refs.fileInput.value = "";
      }
      vm.isUpload = false;
      vm.contractDialog = false;
    },
    openCpLogDialog() {
      let vm = this;
      vm.cpLogDialog = true;
      vm.getPaginatedCpLogList();
    },
    closeCpLogDialog() {
      let vm = this;
      vm.cpLogDialog = false;
    },
    showEmailHistory() {
      let vm = this;
      vm.emailHistoryDialog = true;
    },
    changeEmail() {
      let vm = this;
      vm.$dialog
        .confirm(
          'Are you sure you want to change the email address from ' +
            vm.editedItem.dealerEmail +
            ' to ' +
            vm.newDealerEmail +
            '?'
        )
        .then(() => {
          return vm.checkDealerEmailAddressExist({
              ubDealerID: vm.editedItem.ubDealerID,
              email: vm.newDealerEmail,
            })
            .catch(() => null);
        })
        .then(result => {
          if (!result) return;
          if (result.exists) {
            return vm.$dialog
              .confirm(
                'The email address ' +
                  vm.newDealerEmail +
                  ' already was previously used. Do you want to reactivate it?'
              )
              .then(() => vm.saveDealerEmailChange());
          }
          return vm.saveDealerEmailChange();
        });
    },
    saveDealerEmailChange() {
      let vm = this;
      var payload = {
        ubDealerID: vm.editedItem.ubDealerID,
        email: vm.newDealerEmail,
        replacedEmail: vm.editedItem.dealerEmail,
        requestedBy: vm.requestedBy,
        jiraCard: vm.jiraCard,
      }
      return vm
        .recordDealerEmailChange(payload)
        .then(() => {
          const savedEmail = vm.newDealerEmail;
          vm.emailHistoryDialog = false;
          vm.newDealerEmail = '';
          vm.requestedBy = '';
          vm.jiraCard = '';
          vm.editedItem.dealerEmail = savedEmail;
          return vm.getDealerEmailAddressLog(vm.editedItem.ubDealerID);
        })
        .then(data => {
          vm.emailHistory = data || [];
        })
        .catch((err) => {
          vm.setMessage(
            new httpError({
              message: 'error: ' + err.message,
              httpStatus: err.response && err.response.status || 500,
            })
          );
        });
    }
  },
  watch: {
    pagination: {
      handler(curr) {
        let vm = this;
        vm.getPaginatedDealerList();
      },
      deep: true,
    },
    cpPagination: {
      handler(curr) {
        let vm = this;
        vm.getPaginatedCpLogList();
      },
      deep: true,
    },
    SearchText(val) {
      let vm = this;
      if (val !== null) {
        if (val.length > 3 || val == '') vm.getPaginatedDealerList();
      }
    },
    cpSearchText(val) {
      let vm = this;
      if (val !== null) {
        if (val.length > 3 || val == '') vm.getPaginatedCpLogList();
      }
    },
    userGroup(val) {
      let vm = this;
      vm.pagination.page = 1;
      vm.getPaginatedDealerList();
    },
    showRejected(val) {
      let vm = this;
      vm.getPaginatedDealerList();
    },
    showDeactivated(val) {
      let vm = this;
      vm.getPaginatedDealerList();
    },
  },
  mounted() {
    let vm = this;

    this.$nextTick(() => {
      vm.setMessage(new httpError());
      vm.getDealerTypes();
      //vm.getDataFromApi();
      vm.listDealersManagement()
        .then(data => {
          vm.items = data;
          vm.total = data.length;
          vm.loading = false;
        })
        .catch(() => {});
      vm.getPaginatedDealerList();
    });
  },
};
</script>
<style>
.email-container {
  position: relative;
}
.history-icon {
  position: absolute;
  right: 10px;
  top: 5px;
}
.history-icon:hover {
  opacity: 0.7;
}
</style>
